var _ellipse, _circle, _circle2, _circle3, _circle4, _circle5, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25.4545,
    rx: 25,
    ry: 25.4545,
    fill: "#007A87",
    fillOpacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 16,
    fill: "#007A87"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 15.5,
    stroke: "#001024",
    strokeOpacity: 0.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3565,
    cy: 19.9532,
    r: 0.29984,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1573,
    cy: 19.9532,
    r: 0.29984,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.96,
    cy: 19.9532,
    r: 0.29984,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7569,
    cy: 19.9532,
    rx: 0.299841,
    ry: 0.29984,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8691 30.0474C18.3689 30.3472 20.4778 30.767 22.5167 30.0474C25.0653 29.1479 26.4146 29.4477 28.0637 30.1973C29.7128 30.9469 31.6618 30.3472 32.2615 30.0474",
    stroke: "white",
    strokeWidth: 0.495833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8691 32.0469C18.3689 32.3468 20.4778 32.7665 22.5167 32.0469C25.0653 31.1474 26.4146 31.4472 28.0637 32.1968C29.7128 32.9464 31.6618 32.3468 32.2615 32.0469",
    stroke: "white",
    strokeWidth: 0.495833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7244 30.4953L18.1758 24.7983L20.8743 23.2991M25.0721 21.0503V26.2975M25.0721 21.0503L20.8743 23.2991M25.0721 21.0503L29.2699 23.2991M29.4198 30.4953L31.9684 24.7983L29.2699 23.2991M20.8743 23.2991V18.1519H22.9732H27.171H29.2699V23.2991",
    stroke: "white",
    strokeWidth: 0.495833
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedShip);
export default __webpack_public_path__ + "static/media/selected-ship.5e2a6f968524750984c3f5a3f70329b2.svg";
export { ForwardRef as ReactComponent };